<template>
    <div v-show="logueado" id="prealerta" class="container">
        <div id="crear" v-if="crear" class="separador contenido bg-white br-2-blue container-form">
            <form @submit.prevent="contenido">
                <h2 class="text-center">Crear Prealerta</h2>
                <p class="text-center text-danger font-weight-bold">Todos los campos son obligatorios</p>
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label id="labelColor">Tracking *</label>
                        <input id="tracking" name="tracking" v-model="preAlerta.tracking" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('tracking') }" class="form-control" placeholder="Tracking" type="text" />
                        <span v-show="errors.has('tracking')" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                    <div class="form-group col-md-6">
                        <label id="labelColor">Contenido *</label>
                        <input name="contenido" v-model="preAlerta.contenido" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('contenido') }" class="form-control" placeholder="Contenido" type="text" />
                        <span v-show="errors.has('contenido')" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-4 col-lg-6">
                        <label id="labelColor">Destinatarios *</label>
                        <select class="form-control" v-model="preAlerta.destinatario_id" name="destinatario" v-validate="'required'" :class="{ 'is-invalid': submitted && errors.has('destinatario') }">
                        <option
                            v-for="destinatario in destinatarios"
                            :value="destinatario.id"
                            v-bind:key="destinatario.id"
                        >{{destinatario.nombre_completo}}</option>
                        </select>
                    </div>
                    <div class="col-md-8 col-lg-6">
                        <div class="form-row">
                            <div class="form-group" :class="{'col-md-12': (preAlerta.valor_comercial <= 150), 'col-md-6': (preAlerta.valor_comercial > 150)}">
                                <label id="labelColor">Valor factura en dolares *</label>
                                <input name="valor_comercial" v-model="preAlerta.valor_comercial" class="form-control" type="number" v-validate="'required'" @change="setValorAsegurado()" step="0.01" :class="{ 'is-invalid': submitted && errors.has('valor_comercial') }" />
                                <span v-show="errors.has('valor_comercial')" class="invalid-feedback">Este campo es requerido</span>
                            </div>
                            <div v-show="preAlerta.valor_comercial > 150" class="form-group col-md-6">
                                <label id="labelColor" style="text-decoration: underline" v-b-tooltip:hover title="El valor del seguro es del 2.2% del valor de factura. Máximo $500.00">Adicionar Seguro?</label><br>
                                <b-form-checkbox v-model="checked_valor_asegurado" name="check-button" switch></b-form-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div class="form-row">
                    <div class="form-group col-md-6">
                        <label id="labelColor">Copia Factura *</label>
                        <p class="font-weight-bold">Solo se permite subir archivos PDF o IMAGENES</p>
                        <b-form-file v-model="preAlerta.factura" :state="file_valid" placeholder="Seleccione un archivo ..." drop-placeholder="Drop file here..."  browse-text="Buscar" v-validate="'required'" accept=".pdf, image/*"></b-form-file>
                        <span v-show="!file_valid" class="invalid-feedback">Este campo es requerido</span>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-md-12 text-center">
                        <a class="btn btn-dark" @click="closeCrear()" role="button" href="#">Cancelar</a>
                        <button class="btn btn-dark ml-4 btn-blue">Guardar</button>
                    </div>
                </div>
            </form>
        </div>
        <div v-if="!crear" id="filtros" class="separador contenido bg-white br-2-blue">
            <h2 class="text-center">Prealertas</h2>
            <div class="form-row">
            <div class="form-group col-md-5">
            <label>Fecha Inicio</label>
            <div class="col-md-10 col-lg-10 col-sm-12 p-0">
                <input class="form-control" type="date" v-model="buscar.fechaIni" name="fechaIni" />
            </div>
            </div>
            <div class="form-group col-md-5">
            <label>Fecha Fin</label>
            <div class="col-md-10 col-lg-10 col-sm-12 p-0">
                <input class="form-control" type="date" v-model="buscar.fechaFin" name="fechaFin" />
            </div>
            </div>
            <div class="form-group col-md-2">
            <label id="labelColor">Activo</label>
            <select class="form-control" name="estado" v-model="buscar.estado">
                <option value="1">Si</option>
                <option value="0">No</option>
                <option value="3" selected>Ambos</option>
            </select>
            </div>
            <div class="form-group col-md-12 d-flex justify-content-end">
            <button class="btn btn-blue btn-block col-md-2" @click="buscarFiltro()"><b-icon icon="search" aria-hidden="true"></b-icon> Buscar</button>
            </div>
        </div>
        </div>
        <div v-if="!crear" id="listar" class="separador contenido bg-white br-2-blue">
        <div class="panel panel-default">
            <div class="wrapper">
            <form class="form ng-pristine ng-valid">
                <div class="row mb-3">
                <div class="col-md-4 col-sm-4 col-xs-4 col-lg-3">
                    <a
                    class="btn btn-blue"
                    @click="toogle()"
                    role="button"
                    href="#"
                    ><b-icon icon="plus-circle-fill" aria-hidden="true"></b-icon> Crear</a>
                </div>
                <div class="form-row text-center justify-content-center col-md-4 col-sm-5 col-xs-6 col-lg-6">
                    <label class="col-md-5 col-lg-2">Registros</label>
                    <div>
                        <select
                            class="form-control"
                            name="registros"
                            v-validate="'required'"
                            @change="changePage()"
                            :class="{ 'is-invalid': submitted && errors.has('registros') }"
                            v-model="registros"
                        >
                            <option selected="selected" value="15">15</option>
                            <option value="30">30</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                        </select>
                    </div>  
                </div>
                </div>
            </form>
            </div>
            <div class="table-responsive app-table">
            <table class="table table-striped b-t table-color" id="my-table">
                <thead>
                <tr>
                    <th>Opciones</th>
                    <th>Activo</th>
                    <th>Retener</th>
                    <th>ID</th>
                    <th>Fecha</th>
                    <th>Tracking</th>
                    <th>Destinatario</th>
                    <th>Tienda</th>
                    <th>Contenido</th>
                    <th>Val. Asegurado</th>
                    <th>Val. Comercial</th>
                    <th>Orden de Compra</th>
                    <th>Notas</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="preAle in preAlertas" v-bind:key="preAle.id">
                    <td>
                      <span v-if="preAle.factura" @click="imprimir(preAle.factura)" class="btn-print">
                        <b-icon icon="printer-fill" aria-hidden="true" title="Imprimir"></b-icon>
                      </span>
                    <span
                        v-on:click="eliminar(preAle)"
                        class="btn-trash ml-3"
                        >
                        <b-icon icon="trash-fill" aria-hidden="true" title="Eliminar"></b-icon>
                    </span>
                    </td>
                    <td>
                    <span v-if="preAle.estado">Activa</span>
                    <span v-else>Inactiva</span>
                    </td>
                    <td>
                    <span v-if="preAle.retener">Si</span>
                    <span v-else>No</span>
                    </td>
                    <td class="ng-binding">{{preAle.id}}</td>
                    <td class="ng-binding">{{preAle.fecha}}</td>
                    <td class="ng-binding">{{preAle.tracking}}</td>
                    <td class="ng-binding">{{preAle.destinatario.nombre_completo}}</td>
                    <td class="ng-binding">{{preAle.tienda.razon_social}}</td>
                    <td class="ng-binding">{{preAle.contenido}}</td>
                    <td class="ng-binding">{{preAle.valor_asegurado}}</td>
                    <td class="ng-binding">{{preAle.valor_comercial}}</td>
                    <td class="ng-binding">{{preAle.orden_de_compra}}</td>
                    <td class="ng-binding">{{preAle.notas}}</td>
                </tr>
                <tr v-if="preAlertas.length == 0 && !cargando">
                    <td colspan="14" class="text-center">No hay resultados</td>
                </tr>
                </tbody>
            </table>
            <div v-show="cargando" class="text-center app-bkg-color-f5 app-no-data-table b-t" >
                <Cargando/>
            </div>
            </div>
            <div class="panel-footer">
            <b-pagination
                v-model="actualPagina"
                :total-rows="totalRegistros"
                :per-page="registros"
                aria-controls="my-table"
                align="right"
                v-on:input="changePage"
            ></b-pagination>
            </div>
        </div>
        </div>
  </div>
</template>

<script>
import { api } from "@/plugins/api_conect";
import Cargando from '../layouts/Cargando.vue';

export default {
    computed: {
        logueado() {
            return this.$store.getters.loggedIn;
        }
    },
    components: {
      Cargando
    },
    methods: {
        setValorAsegurado(){
            this.preAlerta.valor_asegurado = !this.checked_valor_asegurado? 0: (this.preAlerta.valor_comercial <= 500) ? this.preAlerta.valor_comercial : 500
          console.log(this.preAlerta.valor_asegurado)
        },
        buscarFiltro() {
            let d1 = null;
            if (this.buscar.fechaIni){
                d1 = this.buscar.fechaIni;
            }
            let d2 = null;
            if (this.buscar.fechaFin){
                d2 = this.buscar.fechaFin;
            }

            let estado = this.buscar.estado == 3 ? null : this.buscar.estado;

            if (d1 < d2) {
                api().get(`/api/casillero/clientes/prealertasGet/${this.registros}/${estado}/${d1}/${d2}/null?page=${this.actualPagina}`, {
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                        },
                    })
                    .then(response => {
                        const { data } = response;

                        this.preAlertas = data["datos"]["data"];
                        this.totalRegistros = data["datos"]["total"];
                        this.totalPaginas = data["datos"]["last_page"];
                        this.actualPagina = data["datos"]["current_page"];
                    }, async err => {
                        if (err.response.status === 401) {
                            this.$swal("error", "Error de autentificación", "error");
                            await this.$auth.refreshToken();
                            this.buscarFiltro();
                        } else {
                            this.$swal("error", "Error", "error");
                        }
                    }).catch( () => {
                        this.$swal('¡ERROR!', 'Ha ocurrido un error al consultar las prealertas')
                    });
            } else {
                this.$swal(
                    "error",
                    "La fecha final debe ser posterior a la inicial.",
                    "error"
                );
                this.checked = true;
            }
        },
        eliminar(preAlerta) {
            this.preAlerta = preAlerta;

            if(!this.preAlerta.estado){
                this.$swal("error", "No se puede eliminar su prealerta, favor comunicarse con servicio al cliente", "error");
                return;
            }

            api().delete(`/api/casillero/prealertas/${preAlerta.id}`, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                },
            })
            .then(response => {
                this.$swal('¡Exito!', response.data.msg, 'success');
                this.changePage();
            }, async err => {
                if (err.response.status === 401) {
                    this.$swal("error", "Error de autentificación", "error");
                    await this.$auth.refreshToken();
                    this.eliminar(preAlerta);
                } else {
                    let mensaje = err.response.data.msg ?? "Error";
                    this.$swal("error", mensaje, "error");
                }
            }).catch( () => {
                this.$swal('¡ERROR!', 'Ha ocurrido un error al eliminar la prealerta');
            });
        },
        changePage() {
            this.preAlertas = [];
            this.cargando = true;
            let d1 = null;
            if (this.buscar.fechaIni){
                d1 = new Date(this.buscar.fechaIni);
            }
            let d2 = null;
            if (this.buscar.fechaFin){
                d2 = new Date(this.buscar.fechaFin);
            }
            let estado = this.buscar.estado == 3 ? null : this.buscar.estado;

            api().get(`/api/casillero/clientes/prealertasGet/${this.registros}/${estado}/${d1}/${d2}/null?page=${this.actualPagina}`, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                    },
                })
                .then(response => {
                    const { data } = response;
                    this.cargando = false;
                    this.preAlertas = data["datos"]["data"];
                    this.totalRegistros = data["datos"]["total"];
                    this.totalPaginas = data["datos"]["last_page"];
                    this.actualPagina = data["datos"]["current_page"];

                },async err => {
                    if (err.response.status === 401) {
                        this.$swal("error", "Error de autentificación", "error");
                        await this.$auth.refreshToken();
                        this.buscarFiltro();
                    } else {
                        this.$swal("error", "Error", "error");
                    }
                }).catch( () => {
                    this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener las prealertas', 'error')
                });
        },
        toogle() {
            this.crear = true;
            this.$nextTick(() => {
                if (this.destinatarios.length > 0)
                    this.preAlerta.destinatario_id = this.destinatarios[0].id;
            });
            this.clean();
        },
        closeCrear() {
            this.crear = false;
            this.clean();
            this.changePage();
        },
        clean() {
            this.preAlerta = {
                tracking: "",
                cliente_id: "",
                tienda_id: "",
                contenido: "",
                destinatario_id: "",
                valor_comercial: 1,
                valor_asegurado: 0,
                posicion_arancelaria_id: 2,
                orden_de_compra: "",
                factura: [],
                notas: "",
                estado: true,
                retener: false
            };
            this.checked_valor_asegurado = false;
            this.file_valid = true;
        },
        submit() {
            this.submitted = true;
            if (this.preAlerta.factura == null || this.preAlerta.factura == "")
                this.file_valid = false;

            this.$validator.validate().then(valid => {
                if (valid) {

                    var destinatario_id = this.preAlerta.destinatario_id ?? "";

                    let datos = this.preAlerta;
                    datos["posicion_arancelaria_id"] = this.preAlerta.posicion_arancelaria_id;
                    datos["tienda_id"] = 11;
                    datos["tienda_nombre"] = "100PercentPure";
                    datos["destinatario_id"] = destinatario_id;
                    datos["cliente_id"] = localStorage.cliente_id;

                    let url = `/api/casillero/prealertas`;

                    var form_data = new FormData();

                    form_data.append("tracking", datos["tracking"]);
                    form_data.append("cliente_id", datos["cliente_id"]);
                    form_data.append("tienda_id", datos["tienda_id"]);
                    form_data.append("tienda_nombre", datos["tienda_nombre"]);
                    form_data.append("contenido", datos["contenido"]);
                    form_data.append("destinatario_id", datos["destinatario_id"]);
                    form_data.append("valor_comercial", datos["valor_comercial"]);
                    form_data.append("valor_asegurado", datos["valor_asegurado"]);
                    form_data.append("posicion_arancelaria_id",datos["posicion_arancelaria_id"]);
                    form_data.append("orden_de_compra", datos["orden_de_compra"]);
                    form_data.append("factura", datos["factura"]);
                    form_data.append("notas", datos["notas"]);
                    form_data.append("estado", 1);
                    form_data.append("retener", 0);

                    api().post(url, form_data, {
                            headers: {
                                Accept: "application/json",
                                Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                            }
                        })
                        .then(response => {
                            const { data } = response;
                            this.responseMessage = data["msg"];
                            this.$swal({
                                title: 'Proceso completado',
                                text: 'Prealerta creada exitosamente',
                                icon: 'success',
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    this.closeCrear();
                                }
                            });
                            this.clean();
                        }).catch(async (error) => {
                            if (error.response.status === 401) {
                                await this.$swal("error", "Error de autentificación", "error");
                                await this.$auth.refreshToken();
                                this.submit();
                            } else {
                                let mensaje = this.setErrors(error);
                                this.$swal("error", mensaje, "error");
                            }
                        });
                }else{
                    this.$swal("error", "Favor completar los datos obligatorios", "error");
                }
            });
        },
        getDestinatarios() {
            api().get(`/api/casillero/despachos/preliquidaciones/infoform`, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                    }
                })
                .then(response => {
                    const { data } = response;
                    this.destinatarios = data["datos"]["destinatarios"];
                    if(this.destinatarios?.length > 0)
                      this.preAlerta.destinatario_id = this.destinatarios[0]?.id;
                }, () => {
                    this.$swal('¡ERROR!', 'Ha ocurrido un problema al obtener los destinatarios', 'error')
                }).catch( () => {
                    this.$swal('¡ERROR!', 'Ha ocurrido un error al obtener los destinatarios', 'error')
                });
        },
        setErrors(error) {
            let mensaje = "";
            if (error.response.data["errores"]) {
                for (let err in error.response.data["errores"]) {
                    mensaje += "<p>"+error.response.data["errores"][err]+"</p>";
                }
            }
            mensaje = mensaje == "" ? 'Ocurrio un error': mensaje;
            return mensaje
        },
        contenido() {
            this.submit();
        },
        imprimir(file){
          api().get(`api/casillero/prealertas/imprimir/${file}`, {
            headers: {
              Accept: "application/json",
              Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
            },
            responseType: 'blob'
          }).then(res => {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url
            link.setAttribute('download', file)
            document.body.appendChild(link)
            link.click()
            link.parentNode.removeChild(link)
          }, err => this.$swal('ERROR', `No se pudo obtener el documento soporte\n${err}`, 'error'))
              .catch(() => this.$swal('ERROR', 'Ha ocurrido un error al obtener el documento soporte', 'error'))
        }
    },
    data() {
        return {
            checked: false,
            checked_valor_asegurado: false,
            file_valid: true,
            cargando: false,
            crear: false,
            checkTienda: false,
            submitted: false,
            responseMessage: "",
            file: [],
            destinatarios: "",
            selectDestinatario: "",
            tiendas: null,
            arrayTiendas: "",
            selectPosicion: null,
            posiciones: "",
            preAlerta: {
                tracking: "",
                cliente_id: "" /*localStorage.cliente_id*/ ,
                tienda_id: "",
                tienda_nombre: "Amazon",
                contenido: "",
                destinatario_id: "",
                valor_comercial: 100,
                valor_asegurado: 0,
                posicion_arancelaria_id: 2,
                orden_de_compra: "",
                factura: "",
                notas: "",
                estado: true,
                retener: false
            },
            preAlertas: "",
            registros: 15,
            actualPagina: 1,
            totalPaginas: 0,
            totalRegistros: 0,
            buscar: {
                fechaIni: "",
                fechaFin: "",
                estado: 3,
                pageSize: 15
            }
        };
    },
    mounted: async function() {
        await this.$auth.refreshToken();
        this.getDestinatarios();
        this.changePage();
    },
    watch: {
      checked_valor_asegurado() {
        this.setValorAsegurado();
      }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.contenido {
    margin-top: 25px;
    margin-bottom: 25px;
    padding: 10px;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.table-color {
    color: black !important;
    background: aliceblue !important;
}
.container-form {
    padding-left: 25px;
    padding-right: 25px;
    padding-bottom: 4px;
    margin-top:25px;
}
.btn-trash:hover, .btn-print:hover{
    color: var(--primary-color) !important;
    cursor: pointer;
}
</style>